const PRIORITIES = [
  {
    n: "01",
    title: "Safer Streets for Everyone",
    text: "Advocate for an integrated diversion and enforcement approach to address mental health crisis, public intoxication, and disorderly conduct in public spaces.",
  },
  {
    n: "02",
    title: "Prioritize Maintenance Over New Development",
    text: "Collins-Bayridge like much of the city has countless examples of road and infrastructure that visibly shows neglect for basic, ongoing maintenance. While expansion of bus stops and transit are important; road maintenance, garbage clean up in our green spaces, and weed control are priorities that must be addressed on an ongoing basis.",
  },
  {
    n: "03",
    title: "Fiscal Responsibility and City Revenues",
    text: "Kingston experiences endless opportunities due to its proximity to major metropolitan areas, location along the 401 corridors, access to the base of the Rideau Canal, and the desirable connection to Lake Ontario. Kingston would be well advised to both preserve the natural and historic draw of the city while leveraging existing locations that could generate permanent revenue for the city. City Council must right course to address fiscal pressures and raising property taxes should not be the mechanism when we have observable missed opportunities throughout the city. Joel is committed to working with city administration and local businesses to support sustainable, mutually beneficial revenue opportunities.",
    source: {
      label: "Fraser Institute (June 2025): Kingston recorded the largest per-person municipal debt increase among Ontario's 35 biggest cities — $2,784 between 2004 and 2023",
      url: "https://www.fraserinstitute.org/commentary/municipal-debt-rising-substantially-some-ontario-cities",
    },
  },
  {
    n: "04",
    title: "Housing West End Families Can Afford",
    text: "We need to review barriers to affordable housing development including zoning, permitting, and the underlying costs that disincentivize local companies from participating in the space. By minimizing the barriers, Kingston can align public and private objectives to address housing needs that have continued to grow over the past 20 years.",
  },
  {
    n: "05",
    title: "Encourage Green Space Preservation",
    text: "Joel will continue to support green space initiatives while harmonizing development opportunities in the city. Through public-private partnership and tangible offsets, we can find solutions that both preserve our natural habitats and afford businesses the flexibility required to responsibly modernize our city.",
  },
];

export const Priorities = () => {
  return (
    <section id="priorities" className="scroll-mt-36 px-6 py-24 md:scroll-mt-24 md:py-32" data-testid="priorities-section">
      <div className="mx-auto max-w-6xl">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#666666]">
          What Joel Stands For
        </p>
        <h2 className="mt-4 font-serif text-3xl font-light leading-tight tracking-tight md:text-5xl">
          Five Commitments to Collins-Bayridge
        </h2>
        <div className="mt-14 grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-px bg-[#DCDCD6]">
              {PRIORITIES.map((p) => (
                <article
                  key={p.n}
                  className="bg-[#F4F4F0] p-8 transition-colors duration-300 hover:bg-[#EBEBE6]"
                  data-testid={`priority-card-${p.n}`}
                >
                  <p className="font-serif text-4xl font-light italic text-[#DCDCD6]">{p.n}</p>
                  <h3 className="mt-4 font-serif text-2xl font-light tracking-tight">{p.title}</h3>
                  <p className="mt-4 text-base leading-relaxed text-[#666666]">{p.text}</p>
                  {p.source && (
                    <a
                      href={p.source.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`priority-source-${p.n}`}
                      className="mt-6 inline-block border-t border-[#DCDCD6] pt-4 text-[10px] font-bold uppercase tracking-[0.2em] text-[#999999] transition-colors duration-300 hover:text-[#111111]"
                    >
                      Source: {p.source.label} →
                    </a>
                  )}
                </article>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-10 lg:col-span-5" data-testid="district-gallery">
          {[
            { src: "/gallery-street.webp", alt: "Intersection with crosswalk and bike lane in Collins-Bayridge", caption: "Underutilized Bayridge Drive public transit project infrastructure" },
            { src: "/gallery-weeds.webp", alt: "Weeds growing beside a stone wall and doorway", caption: "Neglected basic maintenance city wide" },
            { src: "/gallery-fence.webp", alt: "Temporary fencing and closure notice at a Kingston waterfront park", caption: "Gord Downie Memorial Pier - Missed Revenue Opportunity" },
            { src: "https://commons.wikimedia.org/wiki/Special:FilePath/Via_Rail_engine_6404_-_June_2023.jpg?width=1200", alt: "VIA Rail train at a Kingston-area platform", caption: "Up to 350 train whistles disrupt the Collins-Bayridge area every day. This issue can be resolved with a minor upgrade in safety infrastructure at each crossing" },
          ].map((photo, i) => (
            <figure key={photo.src} data-testid={`gallery-item-${i + 1}`}>
              <img
                src={photo.src}
                alt={photo.alt}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover"
                data-testid={`gallery-photo-${i + 1}`}
              />
              <figcaption
                className="mt-3 min-h-6 border-b border-dashed border-[#DCDCD6] pb-2 text-[10px] font-bold uppercase tracking-[0.25em] text-[#999999]"
                data-testid={`gallery-caption-${i + 1}`}
              >
                {photo.caption}
              </figcaption>
            </figure>
          ))}
          </div>
        </div>
      </div>
    </section>
  );
};
